<template>
	<v-dialog v-model="comprarDialog" max-width="500" v-if="dialogQuantidade" class="modal" :scrollable=true>
		<Card>
			<div class="card__fechar">
				<button @click="fecharDialog">
					<v-icon>mdi-close</v-icon>
				</button>
			</div>
			<div class="card__conteudo">
				<PaginaProduto :item="item" @fecharDialog="fecharDialog"/>
			</div>
		</Card>
	</v-dialog>
</template>
<script>
import PaginaProduto from '../../views/Produto.vue'
import Card from '../shared/Card.vue'

export default {
	props: {
		dialogQuantidade: Boolean,
		item: {},
	},
	components: { PaginaProduto, Card },
	computed: {
		comprarDialog: {
			get() {
				return this.dialogQuantidade
			},
			set() {
				this.fecharDialog()
			},
		},
	},
	methods: {
		fecharDialog() {
			this.$emit('fecharDialog')
		},
	},
}
</script>
<style scoped >
.card {
	background-color: var(--v-background-base);
	border-radius: 1rem;
	padding: 1rem 1rem 1.5rem 1rem;
	overflow-y: auto;
	scrollbar-color: var(--v-primary-base) #d9d9d9;
	scrollbar-width: thin;
}

.card__fechar {
	display: flex;
	justify-content: flex-end;
}

::-webkit-scrollbar {
	width: 0.5em;
}

::-webkit-scrollbar-track {
	background: #d9d9d9;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb {
	background: #6d6767;
	border-radius: 100vw;
}

::-webkit-scrollbar-thumb:hover {
	background: var(--v-primary-base);;
}
</style>